module.exports = __webpack_public_path__ + "static/media/118890505_918769108611346_2033448167121031748_n.d5e740b2.jpg";